function obterUsuarioAtualStorage() {
  var usuario = localStorage.getItem("usuario-gpc");

  if (usuario) {
    usuario = atob(usuario);
    return JSON.parse(usuario);
  }
  return undefined;
}

function obterIdPerfilTokenUsuarioAtualStorage() {
  let token = obterTokenNaStorage();
  let trechoTokenUsuario = token.split(".")[1];

  let usuario = JSON.parse(atob(trechoTokenUsuario));
  return parseInt(usuario.role);
}

function salvarUsuarioNaStorage(usuario) {
  usuario = btoa(JSON.stringify(usuario));
  localStorage.setItem("usuario-gpc", usuario);
}

function salvarTokenNaStorage(token) {
  localStorage.setItem("token-gpc", token);
}

function obterTokenNaStorage() {
  return localStorage.getItem("token-gpc");
}

function removerAutenticacao() {
  localStorage.removeItem("token-gpc");
  localStorage.removeItem("usuario-gpc");
}

export default {
  obterUsuarioAtualStorage,
  obterIdPerfilTokenUsuarioAtualStorage,
  salvarUsuarioNaStorage,
  salvarTokenNaStorage,
  obterTokenNaStorage,
  removerAutenticacao
};
